import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ThemeState {
  selectedThemeId: number | null;
}

const initialState: ThemeState = {
  selectedThemeId: null,
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setSelectedThemeId: (state, action: PayloadAction<number>) => {
      state.selectedThemeId = action.payload;
    },
    resetTheme: (state) => {
      state.selectedThemeId = null;
    },
  },
});

export const { setSelectedThemeId, resetTheme } = themeSlice.actions;

export default themeSlice.reducer;
